export const STOP_ALL_LOADING = 'STOP_ALL_LOADING'

export const stopAllLoading = () => ({ type: STOP_ALL_LOADING })
